export default "__VITE_ASSET__C03tmi0O__"